<template>
    <div class="main">
        <profile-banner v-if="isDesktopDevice" class="mb-10"/>
        <div v-else class="profile-heading mt-5 mb-3">My Profile</div>
        <ProfileDashboard></ProfileDashboard>
        <div class="my-8"></div>
    </div>
</template>



<script setup>

import { isDesktop } from "@/utils/utils.ts";
import ProfileDashboard from "../components/Profile/Profile-Dashboard.vue";
import ProfileBanner from "@/components/Profile/Profile-Banner.vue";

const isDesktopDevice = isDesktop();

</script>